import BaseTrack from "./basetracks";

class EmptyTrack extends BaseTrack
{
    constructor (type, datas, file1, file2, channel, id, parent)
    {
        super (type, datas, file1, file2, channel, id, parent);

        this.defaultHeight = 80;
        this.minHeight = 50;
        this.maxHeight = 80;


        this.height = this.defaultHeight;

        var style = getComputedStyle(document.body);
        this.backcolor = style.getPropertyValue('--timeline-emptytrack-backcolor');        


  }



  
}

export default EmptyTrack;